export default "__VITE_ASSET__DGgzpVy$__"